import { render, staticRenderFns } from "./FinishedGoodsOutboundAdd.vue?vue&type=template&id=2a804670&scoped=true"
import script from "./FinishedGoodsOutboundAdd.vue?vue&type=script&lang=js"
export * from "./FinishedGoodsOutboundAdd.vue?vue&type=script&lang=js"
import style0 from "./FinishedGoodsOutboundAdd.vue?vue&type=style&index=0&id=2a804670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a804670",
  null
  
)

export default component.exports